module.exports = __webpack_public_path__ + "img/logo_Q_PluginUI_W.ec94a9d8.svg";